import CustomButton from 'components/buttons/CustomButton/CustomButton';
import CustomDialog from 'components/dialogs/CustomDialog'
import { useAuth } from 'context/AuthContext';
import React, { useState } from 'react'

interface Props {
  open: boolean;
  setOpen: (value: boolean) => void;
}

export default function LogoutDialog({ open, setOpen }: Props) {
  const { logout } = useAuth();
  const [loading, setLoading] = useState<boolean>(false);


  const handleLogout = () => {
    setLoading(true);
    setTimeout(() => {
      setOpen(false);
      setLoading(false);
      logout();
    }, 1000);
  };


  return (
    <CustomDialog
      open={open}
      title='Logout'
      message='Are you sure you want to logout?'
      buttons={[
        <CustomButton
          key='cancel'
          text='Cancel'
          variant='outlined'
          onClick={() => setOpen(false)}
          disabled={loading}
        />,
        <CustomButton
          key='logout'
          text='Logout'
          color='error'
          onClick={handleLogout}
          loading={loading}
        />
      ]}
    />
  )
}
